var map = {
	"./ID.webp": 776,
	"./INDO.webp": 777,
	"./MY.webp": 778,
	"./TH.webp": 779,
	"./VN.webp": 780,
	"./malaysia.webp": 781
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 393;
module.exports = webpackAsyncContext;